// extracted by mini-css-extract-plugin
export default {"header":"layout_header__ce+oA","container":"layout_container__T+lEo"};